import { z } from "zod";

const ContactSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  phone_number: z.string().min(7, "Phone number must be more than 7 digits").regex(/^\d+$/, {
    message: "Phone number must contain only digits",
  }),
  email: z.string().email({ message: "Invalid email address" }),
  travel_blogger_types: z
    .array(z.string())
    .optional(),
  tourism_specializations: z
    .array(z.string())
    .min(1, { message: "Please select at least one option" }),
  travel_companions: z
    .array(z.string())
    .min(1, { message: "Please select at least one option" }),
  audience_needs: z
    .array(z.string())
    .min(1, { message: "Please select at least one option" }),
  content_types: z
    .array(z.string())
    .min(1, { message: "Please select at least one option" }),
  social_media_link: z
    .string()
    .url({ message: "Please enter a valid URL" })
    .optional(),
});

export default ContactSchema;